import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Views } from '@awp/constants';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import XYZ from 'ol/source/XYZ';
import { transform } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import Overlay from 'ol/Overlay';
import { REST_API, FORM_MODE } from '@awp/constants';
import { GetFullUrl } from '@awp/helpers/fetchReact';
import { AwpContainer } from '../Common/AwpContainer';

const olContainer = 'ol-container';
let olMap = null;

const vectorSource = (url) => {
  const _vectorSource = new VectorSource({
    format: new GeoJSON(),
    serverType: 'geoserver',
    loader: async (extent) => {
      try {
        let res = await fetch(`${url}&extent=${extent.join(',')}`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!res || !res.ok) throw new Error('Bad response from server');

        const text = await res.text();
        const features = _vectorSource.getFormat().readFeatures(text);
        _vectorSource.addFeatures(features);
      } catch {
        _vectorSource.removeLoadedExtent(extent);
      }
    },
  });

  return _vectorSource;
};
class tileXYZSource extends XYZ {
  constructor(options) {
    super({
      ...options,
      tileLoadFunction: (tile, src) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', src);
        xhr.onload = () => {
          if (xhr.status === 200) {
            tile.getImage().src = src;
          } else {
            tile.setState('error');
          }
        };
        xhr.onerror = () => {
          tile.setState('error');
        };
        xhr.send();
      },
    });
  }
}
const Maps = () => {
  const [currentFeatures, setCurrentFeatures] = useState(null);

  useEffect(() => {
    olMap = '';
    let view = new View({
      projection: 'EPSG:3857',
      center: transform([-124, 51.5], 'EPSG:4326', 'EPSG:3857'),
      zoom: 6,
    });

    document.getElementById('mapPopupContent-Close').onclick = () => {
      overlay.setPosition(undefined);
      return false;
    };

    const overlay = new Overlay({
      element: document.getElementById('mapPopup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    olMap = new Map({
      target: olContainer,
      overlays: [overlay],
      layers: [
        new TileLayer({
          source: new tileXYZSource({
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}/',
          }),
        }),
        new VectorLayer({
          source: vectorSource(`${GetFullUrl(REST_API.MAP_DATA)}`),
        }),
      ],
      view: view,
    });

    olMap.on('click', (evt) => {
      const coordinate = evt.coordinate;
      const features = olMap.forEachFeatureAtPixel(evt.pixel, (feature) => feature);

      if (!features) return;

      setCurrentFeatures(features);

      overlay.setPosition(coordinate);
    });
  }, []);

  return (
    <AwpContainer>
      <div>
        <div id={olContainer} />

        <div id="mapPopup" style={{ width: '20rem', height: '8rem' }}>
          <div
            className="popover fade show bs-popover-right"
            role="tooltip"
            // eslint-disable-next-line react/no-unknown-property
            x-placement="right"
            style={{ width: '20rem', top: '-50%', height: '100%', left: '0.75rem' }}
          >
            <div className="arrow" style={{ top: '3rem' }}></div>
            <span
              id="mapPopupContent-Close"
              className="float-right mr-2 p-1 font-weight-bold"
              style={{ cursor: 'pointer' }}
              onClick={() => {}}
            >
              &times;
            </span>
            <h3 className="popover-header" id="mapPopupContent">
              {currentFeatures?.values_?.NAME} ({currentFeatures?.values_?.WEATHER_STATION_NUMBER})
            </h3>
            <div className="popover-body" id="mapPopupContent-Actions">
              <Link
                to={Views.WeatherStation}
                state={{ id: currentFeatures?.values_?.WEATHER_STATION_ID, mode: FORM_MODE.VIEW }}
              >
                View Weather Station
              </Link>
              <br></br>
              <Link
                to={Views.WeatherStation}
                state={{ id: currentFeatures?.values_?.WEATHER_STATION_ID, mode: FORM_MODE.EDIT }}
              >
                Edit Weather Station
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AwpContainer>
  );
};

export default Maps;
